import { Stack } from "@mui/material";
import { FillInfoIcon, LikeIcon } from "Assets/icons";
import { GreenButton } from "Components/button/index";
import { Link } from "Components/link";
import { StarRating } from "Components/rating";
import {
  SmTextSemibold,
  XlTextSemiBold,
  XsText
} from "Components/Text";
import Tooltip from "Components/tooltip/Tooltip";
import { COLORS } from "constants/layout";
import {
  DIRECT_PATHS,
  PATHS,
  SEARCH_PARAM_VALUES,
  SEARCH_PARAMS,
} from "constants/routes";
import { objectToQueryString } from "helpers/search";
import { useTranslation } from "hooks/useTranslation";
import { memo } from "react";
import { useHistory } from "react-router-dom";

type Props = {
  data?: {
    count_review?: number;
    trust_star?: number;
    name?: string;
  };
  customPath?: string;
  externalResourceLink?: string;
};

const RatingInfors = (props: Props) => {
  const { data, customPath, externalResourceLink } = props;
  const t = useTranslation();
  const { count_review = 0, trust_star = 0, name } = data || {};
  const history = useHistory();

  // Hàm điều hướng thống nhất với tham số actionType để xác định hành động
  const navigate = (actionType: "writeReview" | "viewReviews") => {
    // Ưu tiên link bên ngoài nếu được cung cấp
    const suffix = {
      writeReview: "?popup=review",
      viewReviews: "?tab=reviews",
    };
    if (externalResourceLink) {
      window.location.href = externalResourceLink + suffix[actionType];
      return;
    }

    // Xác định đường dẫn nội bộ
    const basePath = customPath || DIRECT_PATHS.supplierDetail(name);

    // Xác định tham số query dựa trên loại action
    let queryParams = {};

    switch (actionType) {
      case "writeReview":
        // Hiển thị popup đánh giá
        queryParams = {
          [SEARCH_PARAMS.popup]: SEARCH_PARAM_VALUES.popupReview,
        };
        break;
      case "viewReviews":
        // Chuyển đến tab review
        queryParams = { tab: "review" };
        break;
    }

    // Điều hướng đến đường dẫn nội bộ với tham số query
    history.push({
      pathname: basePath,
      search: objectToQueryString(queryParams),
    });
  };

  return (
    <Tooltip
      title={
        <Stack
          p={2}
          bgcolor={COLORS.gray[50]}
          minWidth={256}
          alignItems="center"
        >
          <Stack direction="row" spacing={0.5} alignItems="center">
            <SmTextSemibold color="#FFC01F">{t("trust_stars")}</SmTextSemibold>
            {/* Icon thông tin */}
            <Link to={PATHS.trustStar}>
              <FillInfoIcon />
            </Link>
          </Stack>
          <XlTextSemiBold mb={0.5} color="#FFC01F">
            {(trust_star || 0).toFixed(1)}/5
          </XlTextSemiBold>
          <StarRating value={trust_star} readOnly />
          {/* Nút viết đánh giá */}
          <GreenButton
            startIcon={<LikeIcon fill="#fff" />}
            sx={{ mt: 2 }}
            onClick={() => navigate("writeReview")}
          >
            {t("write_a_review")}
          </GreenButton>
          {/* Hiển thị số lượng đánh giá */}
          {count_review > 0 && (
            <XsText
              color="#333333"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                navigate("viewReviews");
              }}
              mt={1}
              className="hover-underline"
              style={{ cursor: "pointer" }}
            >
              {count_review} {t(`review${count_review > 1 ? "s" : ""}`)}
            </XsText>
          )}
        </Stack>
      }
    >
      <Stack direction="row" spacing={0.5} width="fit-content">
        <StarRating value={trust_star} readOnly />
      </Stack>
    </Tooltip>
  );
};

export default memo(RatingInfors);
